import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Card } from '@design-system/card';
import { Loader } from '@design-system/loader';
const HandleQueryErrorDefault = (error) => {
    throw error;
};
export const BlockDetails = ({ data, dataTestId, getFetchUrl, getItemKey = (item) => item.id, getSelectedId, handleQueryError = HandleQueryErrorDefault, queryId, renderData, }) => {
    const params = useParams();
    const id = getSelectedId(data, params);
    const { data: itemData, isLoading } = useQuery({
        queryKey: [queryId, id],
        queryFn: ({ signal }) => {
            const url = getFetchUrl(id);
            return axios
                .get(url, { signal })
                .then((res) => res.data.request)
                .catch(handleQueryError);
        },
        enabled: Boolean(id),
    });
    if (!id) {
        return null;
    }
    if (!itemData || isLoading) {
        return (_jsx(Card, { "data-testid": `${dataTestId}-loading`, children: _jsx(Loader, { size: 40 }) }));
    }
    const key = getItemKey(itemData);
    return renderData(itemData, dataTestId, key);
};
//# sourceMappingURL=index.js.map